import './App.css';

function App() {
  return (
    <div className="page">
      <div className="bg">
        <span className="orb orb--one" />
        <span className="orb orb--two" />
        <span className="orb orb--three" />
      </div>

      <main className="shell">
        <header className="hero">
          <div className="hero-inner">
            <div className="hero-copy">
              <p className="eyebrow">Software engineering</p>
              <h1>
                Hi, I&apos;m Mohamad.
                <span className="accent"> I craft bold, thoughtful digital products.</span>
              </h1>
              <p className="lead">
                I help founders and teams turn rough ideas into distinctive digital
                products through design, prototyping, and front-end execution.
              </p>
              <div className="cta-row">
                <button
                  className="cta cta--primary"
                  type="button"
                  onClick={() =>
                    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })
                  }
                >
                  Start a project
                </button>
                <a className="cta cta--ghost" href="/CV-ENG.pdf" download>
                  Download my CV
                </a>
              </div>
            </div>

            <div className="hero-photo">
              <div className="photo-ring">
                <img className="photo-image" src="/MoeChar.png" alt="Mohamad Arabi" />
              </div>
              <p className="photo-caption">Based in GMT+1 - Available for new work</p>
            </div>
          </div>
        </header>

        <section className="grid" id="work">
          <div className="card intro">
            <h2>About me</h2>
            <p>
              I'm a software engineer focused on building reliable websites, web
              applications, and mobile apps for small businesses.
            </p>
            <p>
              I have hands-on experience developing everything from clean company
              websites to more complex systems such as dashboards, internal tools,
              and mobile applications.
            </p>
            <p>
              I value clear communication, realistic timelines, and solutions
              that help a business run better without unnecessary complexity.
            </p>
            <div className="meta">
              <div>
                <p className="meta-label">Focus</p>
                <p className="meta-value"> Web + Product UI + Digital Solutions</p>
              </div>
              <div>
                <p className="meta-label">Location</p>
                <p className="meta-value">Remote - GMT+1</p>
              </div>
            </div>
          </div>

          <div className="card offerings">
            <h2>What I offer</h2>
            <ul>
              <li>
                <span>01</span>
                <div>
                  <h3>Websites</h3>
                    <p>Business websites, landing pages, and redesigns</p>
                </div>
              </li>
              <li>
                <span>02</span>
                <div>
                  <h3>Web Applications</h3>
                    <p>Custom web apps tailored to your workflow</p>
                </div>
              </li>
              <li>
                <span>03</span>
                <div>
                  <h3>Mobile Applications</h3>
                    <p>iOS and Android apps designed for your users</p>
                </div>
              </li>
              <li>
                <span>04</span>
                <div>
                  <h3>Automation & Technical Support</h3>
                  <p>Automating repetitive tasks (Excel, reports, data processing). Ongoing support and maintenance if needed</p>
                  </div>
              </li>
            </ul>
          </div>
        </section>

        <section className="metrics">
          <div>
            <h3>3+</h3>
            <p>projects shipped</p>
          </div>
          <div>
            <h3>2 yrs</h3>
            <p>product experience</p>
          </div>
          <div>
            <h3>72h</h3>
            <p>prototype turnaround</p>
          </div>
        </section>

        <footer className="contact" id="contact">
          <div>
            <h2>Let&apos;s build something memorable.</h2>
            <p>
              Tell me about your idea, timeline, and goals. I&apos;ll respond with
              next steps and a clear plan.
            </p>
          </div>
          <div className="contact-links">
            <a className="cta cta--primary" href="mailto:mohamad.arabi.1107@gmail.com">
              Get in touch
            </a>
            <div className="contact-list">
              <a href="https://www.linkedin.com/in/mohamad-arabi-a91773215/">LinkedIn</a>
              <a href="https://github.com/Moe-Ara">GitHub</a>
            </div>
          </div>
        </footer>
      </main>
    </div>
  );
}

export default App;




